import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20modern%20workspace%20with%20minimal%20product%20styling%2C%20warm%20beige%20fabric%20textures%2C%20clean%20cream%20background%20with%20subtle%20shadow%20play%2C%20organized%20fashion%20product%20layout%20on%20wooden%20surface%2C%20soft%20natural%20daylight%20through%20sheer%20curtains%2C%20editorial%20product%20photography%2C%20calm%20sophisticated%20atmosphere%20with%20muted%20earth%20tones&width=1920&height=1080&seq=hero-2026-v2&orientation=landscape"
          alt="BaseTao Spreadsheet workspace"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="animate-fade-in-up">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/90 backdrop-blur-sm border border-background-200/50 mb-6">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-checkbox-circle-fill text-accent-500 text-xs"></i>
            </div>
            <span className="text-xs font-medium text-foreground-600">Independent Research Resource</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-4">
            BaseTao Spreadsheet:
            <br />
            <span className="text-accent-400">The Complete Guide</span> to BaseTao
          </h1>

          <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-8 leading-relaxed">
            Research BaseTao smarter with spreadsheet templates, shipping guides,
            warehouse information, reviews, coupons, comparisons, and practical tools.
            An independent resource for smarter shopping decisions.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-xl text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap inline-flex items-center gap-2 cursor-pointer"
            >
              BaseTao Spreadsheet
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </div>
            </a>
            <Link
              to="/basetao-spreadsheet/"
              className="px-8 py-3.5 bg-background-50/90 backdrop-blur-sm text-foreground-800 rounded-xl text-base font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap inline-flex items-center gap-2 cursor-pointer"
            >
              Read the Full Guide
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 bg-accent-500 text-background-50 rounded-xl text-base font-semibold hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}